/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled, { css } from 'styled-components';
import Colors from 'constants/Colors';
import { darken } from 'polished';
import { Breakpoints } from "../../../../constants/Breakpoints";
import { mediaHelper } from "../../../../utils/src";
import Row from 'components/Grid/Row';
import { GridColumnTitle } from 'components/Form/index';
import { FiraSansBold, Text as TextComponent, FontWeight } from 'components/Text';
import { Field } from 'formik';

const generateStyle = (color, bg, bgFocus, bgActive, args = []) => {
  return css`
  color: ${color};
  background-color: ${bg};
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  &:hover:not(:disabled),
  &:focus:not(:disabled) {
    background-color: ${bgFocus};
    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
  }
  &:active:not(:disabled) {
    background-color: ${bgActive};
  }
  ${args.length >= 1 ? args.join('\n') : ''}
  `;
}

export const Content = styled.div`
  background-color: ${Colors.WHITE};
  border: 1px solid ${Colors.BLUE};
  margin: 0;
  border-radius: 10px
  box-shadow: 0px 17px 17px 6px #5f5f5f1a;
  
  @media screen and (min-width: ${Breakpoints.sm}) {
    margin-top: 40px;
    margin-bottom: 10%;
    border-radius: 15px;
  }
  
  ${mediaHelper.md`
    border-radius: 20px;
  `}
`;

const primaryMixin = generateStyle(Colors.WHITE, Colors.BLUE, darken(0.1, Colors.BLUE), darken(0.2, Colors.BLUE));

export const ButtonContent = styled.div`
  display:flex;
  flex-direction:auto;
  background-color: ${Colors.WHITE};  
  width: auto;

  button{
    padding: 0.01rem 0.01rem;
    font-size:14px;
    flex-wrap: wrap;
    white-space: wrap;

    @media(min-width: ${Breakpoints.sm}) {
      padding: 0.15rem 0.2rem;
    }

    @media(min-width: ${Breakpoints.md}) {
      font-size: unset;
      padding: 0.45rem 0.8rem;
    }

    @media(min-width: ${Breakpoints.xl}) {
      padding: 0.75rem 3.75rem;
    }
  }
`;

export const TableContainer = styled.div`
  width:100%;
  margin-left:20px;
`;

export const Scrollbox = styled.div` 
  overflow-y: auto;
  overflow-x: hidden;

  padding:10px 20px 10px 10px;
  // max-height: 500px;
  
  ::-webkit-scrollbar{
    background:${Colors.WHITE};
    width:8px;
  }
  ::-webkit-scrollbar-thumb {
    background: ${Colors.GRAY[3]};
    border-radius: 15px;
  }
  `;

export const Text = styled.text`
  color:${props => props.secundary ? Colors.PURPLE : Colors.GRAY[6]};
  font-weight: ${FontWeight.SemiBold};
  font-size: ${props => props.small ? '14px' : '16px'};
  text-decoration: ${props => props.underline ? 'underline' : null};
  cursor: pointer;
  text-transform: uppercase;
`;


export const TableHeader = styled.div`
  display:flex;
  flex-direction:row;
  width: 100%;
  height:24px;
  background-color: red;
`;

export const DialogSelect = styled.div`
  width: 100%;  
  margin: 30px 0px 10px 0px;
`;

export const DialogConfirm = styled.button`
  width: calc(50% - 10px);
  margin-left: 10px;
  height: 40px;
  background: ${Colors.BLUE};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer; 
`;


export const DialogCancel = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[0]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const DialogRejected = styled.button`
  width: calc(50% - 10px);
  margin-right: 10px;
  height: 40px;
  background: ${Colors.GRAY[6]};
  border: 0px;
  border-radius: 5px;
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  cursor: pointer;     
`;

export const BorderSwitch = styled.div`  
  background: ${Colors.GRAY[6]};
  padding-left: 1px;
  border-radius: 14px;
  width: 57px;
  padding-top: 1px;
  height: 30px;
  display: -webkit-inline-box;
  margin-left: 20px;

  ${({ newBorder }) =>
    newBorder
      ? css`
          margin-top: 10px;
        `
      : ""}
`;

export const CalendarContainer = styled.div`
  z-index: 55;
  left: 45px;
  position: relative;
`;

export const TagInput = styled.input`
  flex: 1;
  display: none;
  border: none;
  width: 100%;

  &:focus {
    outline: transparent;
  }
`;

export const PlaceHolder = styled.label`
  display: block;
  padding: 0.75rem 3.75rem;
  text-transform: uppercase;
  -webkit-letter-spacing: -0.5px;
  -moz-letter-spacing: -0.5px;
  -ms-letter-spacing: -0.5px;
  letter-spacing: -0.5px;
  font-size: 16px;
  height: 42px;
  width: 100%;
  white-space: nowrap;
  font-weight: bold;
  font-style: normal;
  border: 0 none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, width 0.3s ease,
  border 0.5s ease, border-color 0.5s ease, box-shadow 0.15s ease;
  text-align: center;
  color: #ffffff;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);

  text-align: center;
    ${primaryMixin}
    
  ${mediaHelper.md`
    margin-left: 10px;
    width: auto;
  `}
`;

export const Line = styled.div`
    width: 100%;
    height: 2px;
    margin: 5px 0;
    background-color: ${Colors.GRAY[4]};
`;

export const InlineLabel = styled(TextComponent)`
  display: inline-flex;
  width: 30%;
  vertical-align: middle;
  padding-right: 5px;
  text-transform: none;
  
  font-size: 13px;
  color: ${Colors.GRAY[3]};
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: none;
  }
`;

export const ActionContainer = styled.div`
  display: inline-flex;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  flex-direction: row;
  
  @media screen and (min-width: ${Breakpoints.md}) {
    align-itens: center;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  
  i {
    width: 20px;
    height: 20px;  
  }
  
  i:first-child {
    margin-right: 10px;
  }
  
  i:before {
    background-size: 20px 20px;
    width: 20px;
    height: 20px;
  }
`;


export const MobileContainer = styled.div`
  &.filter-open {
    display: block;
    position: fixed;
    overflow-x: scroll;
    top: 0;
    height: 100%;
    left: 0;
    width: 100%;
    background-color: ${Colors.WHITE};
    z-index: 2000;
    padding: 1rem 2rem;
    
    > div > div {
      background-color: ${Colors.WHITE};
    }
  }
  
  &.filter-close {
    display: none;
  }
  
  .icon-close {
    position: absolute;
    top: 0;
    right: 0;
    margin: 10px 15px;
    font-size: 30px;
  }
  
  @media screen and (min-width: ${Breakpoints.md}) {
    &.filter-open {
      display: unset;
      position: unset;
      overflow-x: unset;
      top: unset;
      height: unset;
      left: unset;
      width: unset;
      background-color: revert;
      z-index: unset;
      padding: unset;
    }
    &.filter-close {
      display: unset;
    }
    .icon-close {
      display: none;
    }
  }
`;

export const MobileFilterOrder = styled.div`
  display: flex;
  flex-direction: column-reverse;
  justify-content: flex-end;
  
  > div:first-child > div {
    text-align: center;
  }
  
  hr {
    width: 100%;
    border: 1px solid ${Colors.GRAY[3]}
  }
  
  @media screen and (min-width: ${Breakpoints.md}) {
    display: block;
    
    hr {
      display: none;
    }
  }
`;

export const MobileLabel = styled.span`
  font-weight: ${FiraSansBold};
  text-transform: uppercase;
  font-size: 16px;
  color: ${Colors.GREEN};
`;

export const RowFilterOrder = styled(Row)`
  border-radius: 10px 10px 0 0;
  margin: 0;
  
  ${GridColumnTitle}{
    color: ${Colors.GRAY[0]};
  }
  
  @media screen and (min-width: ${Breakpoints.md}) {
    margin-bottom: 10px;
    border-radius: unset;
  }
`;

export const Title = styled(Text)`
  color: #FFF;
`

export const RowFilterSearch = styled(Row)`
  background-color: ${Colors.BLUE};
  border-radius: 10px 10px 0 0;
  margin-bottom: 10px;
  padding: 7px 0;
  display: flex;
  
  ${mediaHelper.sm`
    border-radius: 15px 15px 0 0;
  `}
  
  @media screen and (min-width: ${Breakpoints.md}) {
    background-color: ${Colors.BLUE} !important;
    border-radius: 20px 20px 0 0;
    margin-bottom: unset;
    
    > div:first-child {
      display: none;
    }
  }
`;

export const ListContent = styled.div`
  padding: 10px;
`;

export const MobileTitleRow = styled.div`
  padding-left: 8px;
  padding-right: 8px;
  display: flex;
  width: 100%;
  justify-content: space-between;
`;


export const RowFilter = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding: 5px;
`;

export const CheckBoxColumn = styled.div`
  width: 20%;
`;

export const FilterColumn = styled.div`
  width: 100%;
  max-width: 254px;
`;

export const FieldGrid = styled(Field)`
  border-radius: 4px;
  padding-left: 5px;
  vertical-align: middle;
  height: 100%;
`;

export const FilterContainer = styled.div`
  &.filter-close {
    display: none;
  }

  &.filter-open {
    position: absolute;
    right: 0;
    top: 60px;
    background-color: ${Colors.WHITE};
    z-index: 10;
    padding: 15px;
    width: 350px;
    box-shadow: -5px 5px 20px -10px black;

    > div > div {
      background-color: ${Colors.WHITE};  
    }
  }

  @media (max-width: ${Breakpoints.md}) {
    &.filter-close {
      display: none;
    }
  
    &.filter-open {
      position: fixed;
      overflow-x: scroll;
      top: 0;
      height: 100%;
      left: 0;
      width: 100%;
      background-color: ${Colors.WHITE};
      z-index: 2000;
      padding: 10px;
  
      > div > div {
        background-color: ${Colors.WHITE};  
      }
    }
    
    .icon-close {
      position: absolute;
      top: 0;
      right: 0;
      margin: 10px 15px;
      font-size: 30px;
    }
  }
`;

export const FilterSearchContainer = styled.div`
  border-radius: 20px 20px 0 0;
  width: 100%;
  margin-bottom: 10px;
`;

export const RowFilterIcon = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: end;
  flex-direction: row;
  background-color: ${Colors.BLUE};
  border-radius: 20px 20px 0 0;


  @media (max-width: ${Breakpoints.md}) {
    border-radius: 10px 10px 0 0;
  }
`;

export const LeftIcon = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: start;
  flex-direction: row;
  background-color: ${Colors.BLUE};
  border-radius: 20px 20px 0 0;
  margin-bottom: 10px;
  padding: 7px 10px;
  position: relative;

  @media (max-width: ${Breakpoints.md}) {
    border-radius: 10px 10px 0 0;
  }
`;

export const RightIcon = styled.div`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: end;
  flex-direction: row;
  background-color: ${Colors.BLUE};
  border-radius: 20px 20px 0 0;
  margin-bottom: 10px;
  padding: 7px 10px;
  position: relative;

  @media (max-width: ${Breakpoints.md}) {
    border-radius: 10px 10px 0 0;
  }
`;

export const ColIcon = styled.div`
  display: flex;
  margin: 0px;
  padding: 5px;
  justify-content: flex-start;
  align-items: center;
`



export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
`;


export const BoxFolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 20px;
  width: 100%;
  border: solid black 1x;
`;


export const FolderSelect = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  position: rigth;

  span { 
    font-weight: bold;
    margin-right: 10px;
    cursor: pointer;
    
    text-decoration: ${({hasFolderSelect}) => hasFolderSelect ? 'underline' : ''};
  }

  p { 
    padding-left: 4px;
  }
`;


export const RowSearch = styled.div `
  margin-left: auto;
  height: 35px;
  align-items: center;
  justify-content: flex-end;

  span {
    font-size: 15px;
    font-weight: normal;
  }
  
`;

export const TooltipText = styled.div`
`;

export const TooltipBox = styled.div`
  position: absolute;
  top: calc(100% + 10px);
  left: -30px;
  visibility: hidden;
  color: transparent;
  background-color: transparent;
  width: auto;
  padding: 5px 5px;
  border-radius: 4px;
  transition: visibility 0.5s, color 0.5s, background-color 0.5s, width 0.5s,
    padding 0.5s ease-in-out;
  &:before {
    content: "";
    width: 0;
    height: 0;
    left: 30px;
    top: -10px;
    position: absolute;
    border: 10px solid transparent;
    transform: rotate(135deg);
    transition: border 0.3s ease-in-out;
    z-index: 99999;
  }
  div {
    overflow: hidden;
 }
`;

export const TooltipCard = styled.div`
  position: relative;
  & ${TooltipText}:hover + ${TooltipBox} {
    visibility: visible;
    color: ${Colors.WHITE};
    background-color: rgba(0, 0, 0);
    width: auto;
    padding: 8px 8px;
    &:before {
      border-color: transparent transparent rgba(0, 0, 0)
        rgba(0, 0, 0);
    }
    z-index: 3000;
  }
`;

